export default __webpack_public_path__ + "118f2d88ee4e049115faceefec06b993.svg";